import { AuthUser } from '../services/repositories/api-repository';

export type ModuleKey =
  | 'dashboard'
  | 'agencies'
  | 'supervisors'
  | 'agents'
  | 'pos'
  | 'inventory'
  | 'btl'
  | 'logistics'
  | 'configurations'
  | 'roles'
  | 'profile';

export type RouteAccessKey = ModuleKey | 'reports' | 'alerts';

const ROLE_MODULE_ACCESS: Record<AuthUser['role'], ModuleKey[]> = {
  admin: ['dashboard', 'agencies', 'supervisors', 'agents', 'pos', 'inventory', 'btl', 'logistics', 'configurations', 'roles', 'profile'],
  supervisor: ['dashboard', 'agencies', 'agents', 'pos', 'inventory', 'btl', 'logistics', 'profile'],
  agent: ['dashboard', 'profile']
};

// Centralized mock RBAC for shell module visibility until backend RBAC is connected.
export function getAllowedModulesForRole(role: AuthUser['role']): Set<ModuleKey> {
  return new Set(ROLE_MODULE_ACCESS[role] ?? []);
}

// Route-level helper keeps mock sidebar and direct-URL access checks aligned.
export function canAccessMockModule(role: AuthUser['role'], key: RouteAccessKey): boolean {
  if (key === 'reports' || key === 'alerts') {
    return false;
  }

  return getAllowedModulesForRole(role).has(key);
}
